const settings = {
  API_ROOT: 'https://api.staging.socialdatabase.com',
  API_ROOT_DEEPTHOUGHT: 'https://api.staging.xdeepthought.com',
  FB_CLIENT_ID: '1735018493414860',
  // FB_CLIENT_ID: '2120996651552338',
  FB_SCOPE: 'email,public_profile,ads_management,ads_read,pages_show_list',
  // FB_SCOPE: 'email,public_profile,ads_management,ads_read,pages_show_list,manage_pages,instagram_basic',
  GOOGLE_APP_ID: '301033914355-msp0h3hvriqm3c342vilm3earjns0ego.apps.googleusercontent.com',
  SENTRY_URL: 'https://15c591be2f1740d5b38d7ed4eae09cd4@o389230.ingest.sentry.io/5535367',
  LINKEDIN_CLIENT_ID: '78d053vvk5eqs5',
  LINKEDIN_SCOPE: 'r_emailaddress r_ads w_organization_social rw_ads r_basicprofile r_liteprofile r_ads_reporting r_organization_social w_member_social',
  AGENCY_ID: process.env.AGENCY_ID || null,
  MODE: 'production' as 'development'|'test'|'production',
  DASHBOARD_VERSION: process.env.DASHBOARD_VERSION,
  MIXPANEL_TOKEN: '',
  PRO_TARGETING_AUTH_TOKEN: '39d43b1167eb86689ab1e414a0a2d2cdb03c076d',
  EXTENSION_AUTH_TOKEN: '39d43b1167eb86689ab1e414a0a2d2cdb03c076d',
}

export default settings

const missing = Object.entries(settings).filter(([k, v]) => (v as unknown) === undefined).map(([k, v]) => k)
if (missing.length) throw new Error('Missing env variables: ' + missing.join(', '))
